<script setup>
import topImage from '@/assets/images/pages/fineDining1.webp'
import {useRoute} from "vue-router"

import {useUserGroupsStore,useUsersStore} from "@/stores"
import { onMounted, watch } from 'vue'

const route = useRoute()
let thePublicId = Array.isArray(route.params.all) ? route.params.all[0] : route.params.all
thePublicId = thePublicId?.toLowerCase()

const usersStore = useUsersStore()
let loginDialogVerificationType = null
let loginDialogMode = null;
({ loginDialogVerificationType, loginDialogMode } = storeToRefs(usersStore))

const userGroupsStore = useUserGroupsStore()
let guestUserGroup;
({ guestUserGroup } = storeToRefs(userGroupsStore))
userGroupsStore.getGuestUserGroup(thePublicId,"friends")

onMounted(async () => {
  loginDialogVerificationType.value = 'gift'
})

// loginJoinDialog#onClose nulls loginDialogVerificationType on every dialog close,
// so reassert it whenever the dialog reopens — otherwise a second submission on
// the same page mount falls through to the generic register branch.
watch(loginDialogMode, newMode => {
  if (newMode) loginDialogVerificationType.value = 'gift'
})
</script>

<template>
  <div v-if="guestUserGroup">
    <section class="home-masthead">
      <div class="content-wrapper">
        <div
          v-if="guestUserGroup.trialPlanId"
          class="masthead-content"
        >
          <HomeMasthead
            :join-page="true"
            :verified-element="false"
            :book-btn="false"
            :learn-more-first="true"
            activate-text="Request Access"
            :free-plat-dur="guestUserGroup.trialPlanId"
            :for-clients="`for ${guestUserGroup.name}'s friends, if approved`"
            :ios-app-available="false"
            :show-restaurants-link="false"
          />
        </div>
      </div>
    </section>
    <VDivider thickness="2" />
    <HomeMainContent />
  </div>
</template>

<style lang="scss" scoped>
@use "@core/scss/pages/misc.scss";
.v-text-field .v-field--active input {
  opacity: 1;
}

input[type="text"] {
  background: rgba(0, 0, 0, 0);
  border: none;
  outline: none;
}

.verified-icon {
  color: rgb(0, 149, 246);
  width: 1.25rem;
  height: 1.25rem;
  margin-bottom: 4px;
  margin-right: 1px;
}

.masthead-content {
  padding: 0 1rem;
  margin: 1rem 0;
}
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
